<template>
  <div id="alt-header-sp" class="header-mobile-sg">
    <div class="pt-menu-mobile" id="pt-menu-mobile">
      <div class="mobile_logo">
        <a :href="getLangUrl('/', baseUrl, locale)" class="alt-header-sp-logo" rel="home" @click="(event) => { closeMenu(event, true); handleLogoClick() }">
          <NuxtImg width="60" height="51" src="https://www.skjewellery.com/api/wp-content/uploads/nuxt/skj-logo-new.webp" alt="SK Jewellery Logo" class="custom-logo header-logo-mobile" sizes="sm:60px md:60px lg:60px" />
        </a>
      </div>
      <div class="mobile_shipping">
        <!-- <div class="header_country" ref="langDropdownRef">
            <div class="lang-selected" @click="toggleLangDropdown">
                <img class="icon_world" src="https://www.skjewellery.com.my/api/wp-content/themes/skjmy/modules/multi-currency/assets/img/flags/row.svg" width="16" height="16" alt="" />
                <span class="lang-label">{{ currentLang }}</span>
                <svg class="lang-chevron" :class="{ open: langOpen }" xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                    <polyline points="6 9 12 15 18 9"></polyline>
                </svg>
            </div>
            <div class="lang-dropdown" v-show="langOpen">
                <a href="#" @click.prevent="navigateToLocalized(localizedPathEn)" class="item_country lang-option" :class="{ active: !isMsMy }">EN</a>
                <a href="#" @click.prevent="navigateToLocalized(localizedPathMs)" class="item_country lang-option" :class="{ active: isMsMy }">MS</a>
            </div>
        </div> -->
        <div class="country-selector alt-nuxt-sg" >
            <span @click="shopPopupSelectCountry()" class="alt-header-country-selector country-selector_mobile">
                <svg class="icon_shipping" width="15" height="15" viewBox="0 0 15 15" fill="currentColor"
                  xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                  <path d="M8.25 2.625H1.5C1.28906 2.625 1.125 2.8125 1.125 3V9.75C1.125 9.96094 1.28906 10.125 1.5 10.125H1.78125C2.17969 9.46875 2.90625 9 3.75 9C4.57031 9 5.29688 9.46875 5.69531 10.125H7.5H8.25C8.4375 10.125 8.625 9.96094 8.625 9.75V3C8.625 2.8125 8.4375 2.625 8.25 2.625ZM9 11.25H8.8125H8.25H7.5H6C6 12.4922 4.99219 13.5 3.75 13.5C2.50781 13.5 1.5 12.4922 1.5 11.25C0.65625 11.25 0 10.5938 0 9.75V3C0 2.17969 0.65625 1.5 1.5 1.5H8.25C9.07031 1.5 9.75 2.17969 9.75 3V3.75H10.7344C11.0859 3.75 11.4141 3.89062 11.6719 4.14844L13.8516 6.32812C14.1094 6.58594 14.25 6.91406 14.25 7.26562V10.125H14.4375C14.7422 10.125 15 10.3828 15 10.6875C15 11.0156 14.7422 11.25 14.4375 11.25H13.5C13.5 12.4922 12.4922 13.5 11.25 13.5C10.0078 13.5 9 12.4922 9 11.25ZM13.0547 7.125L10.875 4.94531C10.8281 4.89844 10.7812 4.875 10.7344 4.875H9.75V7.125H13.0781H13.0547ZM2.625 11.25C2.625 11.6719 2.83594 12.0234 3.1875 12.2344C3.51562 12.4453 3.96094 12.4453 4.3125 12.2344C4.64062 12.0234 4.875 11.6719 4.875 11.25C4.875 10.8516 4.64062 10.5 4.3125 10.2891C3.96094 10.0781 3.51562 10.0781 3.1875 10.2891C2.83594 10.5 2.625 10.8516 2.625 11.25ZM11.25 10.125C10.8281 10.125 10.4766 10.3594 10.2656 10.6875C10.0547 11.0391 10.0547 11.4844 10.2656 11.8125C10.4766 12.1641 10.8281 12.375 11.25 12.375C11.6484 12.375 12 12.1641 12.2109 11.8125C12.4219 11.4844 12.4219 11.0391 12.2109 10.6875C12 10.3594 11.6484 10.125 11.25 10.125Z"/>
              </svg>
                <slot>Malaysia</slot>
                <svg class="header-country-selector-arrow" width="17" height="17"
                  viewBox="0 0 24 24" fill="none" stroke="currentColor"
                  stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                  aria-hidden="true" style="margin-left:5px">
                <polyline points="6 9 12 15 18 9"/>
              </svg>
                <!-- <img class="header-country-selector-arrow" src="@/assets/images/chevron-down.svg" width="17" height="17" style="margin-left: 5px;" alt="" /> -->
            </span>
        </div>
      </div>
      <div class="mobile_option">
          <div class="alt-header-sp-right alt-header-icons">
            <div class="alt-header-user" ref="userMenu">
            <p style="margin:0;" class="alt-header-icons-user" v-if="userStore.isLogin" @click="toggleHeaderUser($event)">
              <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 30 30" fill="none">
                <path d="M18.75 9C18.75 7.6875 18 6.46875 16.875 5.76562C15.7031 5.10938 14.25 5.10938 13.125 5.76562C11.9531 6.46875 11.25 7.6875 11.25 9C11.25 10.3594 11.9531 11.5781 13.125 12.2812C14.25 12.9375 15.7031 12.9375 16.875 12.2812C18 11.5781 18.75 10.3594 18.75 9ZM9 9C9 6.89062 10.125 4.92188 12 3.84375C13.8281 2.76562 16.125 2.76562 18 3.84375C19.8281 4.92188 21 6.89062 21 9C21 11.1562 19.8281 13.125 18 14.2031C16.125 15.2812 13.8281 15.2812 12 14.2031C10.125 13.125 9 11.1562 9 9ZM6.79688 24.75H23.1562C22.7344 21.7969 20.2031 19.5 17.1094 19.5H12.8438C9.75 19.5 7.21875 21.7969 6.79688 24.75ZM4.5 25.6406C4.5 21 8.20312 17.25 12.8438 17.25H17.1094C21.75 17.25 25.5 21 25.5 25.6406C25.5 26.3906 24.8438 27 24.0938 27H5.85938C5.10938 27 4.5 26.3906 4.5 25.6406Z" fill="#C60C46"/>
                <path d="M18.75 9C18.75 7.6875 18 6.46875 16.875 5.76562C15.7031 5.10938 14.25 5.10938 13.125 5.76562C11.9531 6.46875 11.25 7.6875 11.25 9C11.25 10.3594 11.9531 11.5781 13.125 12.2812C14.25 12.9375 15.7031 12.9375 16.875 12.2812C18 11.5781 18.75 10.3594 18.75 9ZM9 9C9 6.89062 10.125 4.92188 12 3.84375C13.8281 2.76562 16.125 2.76562 18 3.84375C19.8281 4.92188 21 6.89062 21 9C21 11.1562 19.8281 13.125 18 14.2031C16.125 15.2812 13.8281 15.2812 12 14.2031C10.125 13.125 9 11.1562 9 9ZM6.79688 24.75H23.1562C22.7344 21.7969 20.2031 19.5 17.1094 19.5H12.8438C9.75 19.5 7.21875 21.7969 6.79688 24.75ZM4.5 25.6406C4.5 21 8.20312 17.25 12.8438 17.25H17.1094C21.75 17.25 25.5 21 25.5 25.6406C25.5 26.3906 24.8438 27 24.0938 27H5.85938C5.10938 27 4.5 26.3906 4.5 25.6406Z" fill="#C60C46" fill-opacity="0.2"/>
              </svg>
            </p>
            <NuxtLink :to="getLangUrl('/my-account/', baseUrl, locale)" class="alt-header-icons-user" aria-label="My Profile" @click="closeMenu($event, false)" no-prefetch v-else>
              <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 30 30" fill="none">
                <path d="M18.75 9C18.75 7.6875 18 6.46875 16.875 5.76562C15.7031 5.10938 14.25 5.10938 13.125 5.76562C11.9531 6.46875 11.25 7.6875 11.25 9C11.25 10.3594 11.9531 11.5781 13.125 12.2812C14.25 12.9375 15.7031 12.9375 16.875 12.2812C18 11.5781 18.75 10.3594 18.75 9ZM9 9C9 6.89062 10.125 4.92188 12 3.84375C13.8281 2.76562 16.125 2.76562 18 3.84375C19.8281 4.92188 21 6.89062 21 9C21 11.1562 19.8281 13.125 18 14.2031C16.125 15.2812 13.8281 15.2812 12 14.2031C10.125 13.125 9 11.1562 9 9ZM6.79688 24.75H23.1562C22.7344 21.7969 20.2031 19.5 17.1094 19.5H12.8438C9.75 19.5 7.21875 21.7969 6.79688 24.75ZM4.5 25.6406C4.5 21 8.20312 17.25 12.8438 17.25H17.1094C21.75 17.25 25.5 21 25.5 25.6406C25.5 26.3906 24.8438 27 24.0938 27H5.85938C5.10938 27 4.5 26.3906 4.5 25.6406Z" fill="#333333"/>
                <path d="M18.75 9C18.75 7.6875 18 6.46875 16.875 5.76562C15.7031 5.10938 14.25 5.10938 13.125 5.76562C11.9531 6.46875 11.25 7.6875 11.25 9C11.25 10.3594 11.9531 11.5781 13.125 12.2812C14.25 12.9375 15.7031 12.9375 16.875 12.2812C18 11.5781 18.75 10.3594 18.75 9ZM9 9C9 6.89062 10.125 4.92188 12 3.84375C13.8281 2.76562 16.125 2.76562 18 3.84375C19.8281 4.92188 21 6.89062 21 9C21 11.1562 19.8281 13.125 18 14.2031C16.125 15.2812 13.8281 15.2812 12 14.2031C10.125 13.125 9 11.1562 9 9ZM6.79688 24.75H23.1562C22.7344 21.7969 20.2031 19.5 17.1094 19.5H12.8438C9.75 19.5 7.21875 21.7969 6.79688 24.75ZM4.5 25.6406C4.5 21 8.20312 17.25 12.8438 17.25H17.1094C21.75 17.25 25.5 21 25.5 25.6406C25.5 26.3906 24.8438 27 24.0938 27H5.85938C5.10938 27 4.5 26.3906 4.5 25.6406Z" fill="black" fill-opacity="0.2"/>
              </svg>
            </NuxtLink>
            <ul class="dropdown-menu-user" v-if="userStore.isLogin">
              <li><NuxtLink :to="getLangUrl('/my-account/', baseUrl, locale)" aria-label="My Profile" @click="closeUserMenu" no-prefetch>My Profile</NuxtLink></li>
              <li><NuxtLink :to="getLangUrl('/my-account/orders', baseUrl, locale)" aria-label="Orders" @click="closeUserMenu" no-prefetch>Orders</NuxtLink></li>
              <li><NuxtLink :to="getLangUrl('/my-account/edit-account/#change-password', baseUrl, locale)" @click="closeUserMenu" no-prefetch>Reset Password</NuxtLink></li>
              <li><a :href="`${runtimeConfig.public.BASE_URL}api/logout/`" class="menu-logout" @click="closeUserMenu">Logout</a></li>
            </ul>
          </div>
          <NuxtLink :to="`/wishlist/${share_key_cookie.value ? share_key_cookie.value + '/' : ''}`" class="icon_wishlist" aria-label="wishlist" no-prefetch>
            <svg xmlns="http://www.w3.org/2000/svg" style="margin-top:3px;" width="25" height="25" viewBox="0 0 30 30" fill="none">
              <path d="M13.5469 24.9844L13.4531 24.8438L5.25 17.25C3.79688 15.8906 3 14.0156 3 12.0469V11.9062C3 8.625 5.34375 5.76562 8.57812 5.15625C10.4062 4.78125 12.2812 5.20312 13.8281 6.28125C14.25 6.5625 14.625 6.9375 15 7.3125C15.1875 7.125 15.375 6.89062 15.6094 6.70312C15.7969 6.5625 15.9844 6.42188 16.1719 6.28125C17.6719 5.20312 19.5469 4.78125 21.375 5.15625C24.6562 5.76562 27 8.625 27 11.9062V12.0469C27 14.0156 26.1562 15.8906 24.7031 17.25L16.5 24.8438L16.4062 24.9844C16.0312 25.3125 15.5156 25.5469 15 25.5469C14.4375 25.5469 13.9688 25.3125 13.5469 24.9844ZM14.2031 9.79688C14.1562 9.79688 14.1562 9.79688 14.1562 9.75L13.3125 8.8125C12.2344 7.59375 10.5938 7.07812 9 7.35938C6.79688 7.78125 5.25 9.70312 5.25 11.9062V12.0469C5.25 13.4062 5.76562 14.6719 6.75 15.5625L15 23.2031L23.2031 15.5625C24.1875 14.6719 24.75 13.4062 24.75 12.0469V11.9062C24.75 9.70312 23.1562 7.78125 20.9531 7.35938C19.3594 7.07812 17.7188 7.59375 16.6406 8.8125L15.7969 9.75C15.7969 9.79688 15.7969 9.79688 15.75 9.84375C15.5625 10.0312 15.2812 10.1719 15 10.1719C14.6719 10.1719 14.3906 10.0312 14.2031 9.84375V9.79688Z" fill="#333333"/>
              <path d="M13.5469 24.9844L13.4531 24.8438L5.25 17.25C3.79688 15.8906 3 14.0156 3 12.0469V11.9062C3 8.625 5.34375 5.76562 8.57812 5.15625C10.4062 4.78125 12.2812 5.20312 13.8281 6.28125C14.25 6.5625 14.625 6.9375 15 7.3125C15.1875 7.125 15.375 6.89062 15.6094 6.70312C15.7969 6.5625 15.9844 6.42188 16.1719 6.28125C17.6719 5.20312 19.5469 4.78125 21.375 5.15625C24.6562 5.76562 27 8.625 27 11.9062V12.0469C27 14.0156 26.1562 15.8906 24.7031 17.25L16.5 24.8438L16.4062 24.9844C16.0312 25.3125 15.5156 25.5469 15 25.5469C14.4375 25.5469 13.9688 25.3125 13.5469 24.9844ZM14.2031 9.79688C14.1562 9.79688 14.1562 9.79688 14.1562 9.75L13.3125 8.8125C12.2344 7.59375 10.5938 7.07812 9 7.35938C6.79688 7.78125 5.25 9.70312 5.25 11.9062V12.0469C5.25 13.4062 5.76562 14.6719 6.75 15.5625L15 23.2031L23.2031 15.5625C24.1875 14.6719 24.75 13.4062 24.75 12.0469V11.9062C24.75 9.70312 23.1562 7.78125 20.9531 7.35938C19.3594 7.07812 17.7188 7.59375 16.6406 8.8125L15.7969 9.75C15.7969 9.79688 15.7969 9.79688 15.75 9.84375C15.5625 10.0312 15.2812 10.1719 15 10.1719C14.6719 10.1719 14.3906 10.0312 14.2031 9.84375V9.79688Z" fill="black" fill-opacity="0.2"/>
            </svg>
          </NuxtLink>

          <button
            v-if="checkCart"
            class="alt-header-icons-cart"
            aria-label="Cart"
            @click="toggleMiniCart($event)"
          >
            <svg xmlns="http://www.w3.org/2000/svg" style="margin-top: 3px;" width="25" height="25" viewBox="0 0 30 30" fill="none">
              <path d="M12 8.25V10.5H18V8.25C18 6.60938 16.6406 5.25 15 5.25C13.3125 5.25 12 6.60938 12 8.25ZM9.75 12.75H6.75V22.5C6.75 23.7656 7.73438 24.75 9 24.75H21C22.2188 24.75 23.25 23.7656 23.25 22.5V12.75H20.25V15.375C20.25 16.0312 19.7344 16.5 19.125 16.5C18.4688 16.5 18 16.0312 18 15.375V12.75H12V15.375C12 16.0312 11.4844 16.5 10.875 16.5C10.2188 16.5 9.75 16.0312 9.75 15.375V12.75ZM9.75 10.5V8.25C9.75 5.39062 12.0938 3 15 3C17.8594 3 20.25 5.39062 20.25 8.25V10.5H23.25C24.4688 10.5 25.5 11.5312 25.5 12.75V22.5C25.5 24.9844 23.4844 27 21 27H9C6.51562 27 4.5 24.9844 4.5 22.5V12.75C4.5 11.5312 5.48438 10.5 6.75 10.5H9.75Z" fill="#333333"/>
              <path d="M12 8.25V10.5H18V8.25C18 6.60938 16.6406 5.25 15 5.25C13.3125 5.25 12 6.60938 12 8.25ZM9.75 12.75H6.75V22.5C6.75 23.7656 7.73438 24.75 9 24.75H21C22.2188 24.75 23.25 23.7656 23.25 22.5V12.75H20.25V15.375C20.25 16.0312 19.7344 16.5 19.125 16.5C18.4688 16.5 18 16.0312 18 15.375V12.75H12V15.375C12 16.0312 11.4844 16.5 10.875 16.5C10.2188 16.5 9.75 16.0312 9.75 15.375V12.75ZM9.75 10.5V8.25C9.75 5.39062 12.0938 3 15 3C17.8594 3 20.25 5.39062 20.25 8.25V10.5H23.25C24.4688 10.5 25.5 11.5312 25.5 12.75V22.5C25.5 24.9844 23.4844 27 21 27H9C6.51562 27 4.5 24.9844 4.5 22.5V12.75C4.5 11.5312 5.48438 10.5 6.75 10.5H9.75Z" fill="black" fill-opacity="0.2"/>
            </svg>
            <span class="alt-cart-indicator">{{ wooStore.totalItemCart }}</span>
          </button>
          <div class="alt-language-switch"></div>
        </div>
      </div>
    </div>
    <div class="alt-header-sp-top">
      <div class="alt-header-sp-menu">
        <button class="alt-header-hamburger" aria-label="Menu" @click="toggleMenu($event)"><span></span></button>
      </div>

      <!-- <div class="alt-header-sp-right alt-header-icons"> -->
        <form @submit.prevent="handleSearchSubmit" class="alt-header-sp-right alt-header-icons" autocomplete="off">
          <input type="text" name="s" placeholder="I am searching for..." v-model="searchInput"
              :class="isSearchMobile ? 'active' : ''" id="open-search" style="padding: 0px 20px !important;">
          <svg @click.prevent="handleSearchSubmit" version="1.1" class="header-svg header-svg--search" xmlns="http://www.w3.org/2000/svg" fill="#9E9E9E"
            xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="111 -111 371 372"
            style="enable-background:new 111 -111 371 372;" xml:space="preserve">
            <path
              d="M268.1-106.9c6.1,0.9,12.2,1.6,18.2,2.8c30.6,6.2,56.8,20.6,77.9,43.7c28,30.6,40.8,66.9,38,108.3 c-1.9,27.4-11.3,52.3-27.7,74.5c-2.6,3.5-2.3,6.8,0.8,10c32.4,32.4,64.8,64.8,97.2,97.2c4.7,4.7,7.2,9.9,5.2,16.6 c-3,10.1-15.1,14-23.5,7.7c-1.4-1.1-2.7-2.3-3.9-3.6c-32.3-32.3-64.7-64.6-97-97c-2.8-2.8-5.8-3.1-8.9-0.7 c-18.4,13.8-39,22.9-61.7,26.5c-45.5,7.2-85.9-4.5-120.4-35.1c-25.5-22.7-40.5-51.4-46.1-85c-0.7-4.1-1.1-8.2-1.6-12.3 c0-6.4,0-12.8,0-19.2c0.6-4.2,1-8.4,1.8-12.6c5.8-34.4,21.8-63.3,48-86.3c19.2-16.8,41.4-27.6,66.4-32.6c6-1.2,12.1-1.9,18.1-2.8 C255.3-106.9,261.7-106.9,268.1-106.9L268.1-106.9z M372.3,37c-0.6-63-51.5-113.7-113.9-113.4C195.6-76.2,144.7-25.1,145,37.3 c0.3,62.9,50.9,113.6,113.8,113.4C322.7,150.5,372,99.2,372.3,37z" />
          </svg>
        </form>
      <!-- </div> -->
    </div>

    <div id="alt-header-menu-sp" v-if="menus">
        <ul id="alt-megamenu-sp" class="alt-megamenu-items">
          <li class="alt-menu-item" :class="[
            item.layout ? `alt-menu-layout-${item.layout}` : '',
            item.classes && Array.isArray(item.classes) ? item.classes.join(' ') : 'text_show',
            index === menus.main.length - 1 ? 'alt-menu-item-last' : ''
          ]" v-for="(item, index) in menus.main">
            <CustomLink :url="getLangUrl(item.url, baseUrl, locale)" class="alt-mega-link 123" @click="jumpItem($event)" v-if="item.children" alt="">
              <img loading="lazy" decoding="async" class="menu-alt-lazy-img alt-lazy-img" :src="item.img_lazy" :data-original_src="item.img_src" alt="">
              <span v-html="item.title"></span>
            </CustomLink>
            <CustomLink :url="getLangUrl(item.url, baseUrl, locale)" class="alt-mega-link 324" @click="toggleMenu($event)" v-else>
              <img loading="lazy" decoding="async" class="menu-alt-lazy-img alt-lazy-img" :src="item.img_lazy" :data-original_src="item.img_src" alt="" >
              <span v-html="item.title"></span>
            </CustomLink>

            <ul class="alt-sub-megamenu" v-if="item.children">
              <li class="alt-menu-item alt-menu-back" @click="backMenu($event, 1)">
                <div class="alt-menu-back-wrapper">
                  <div class="alt-menu-back-icon"></div>
                  <div class="alt-menu-back-text">{{ item.title }} </div>
                </div>
              </li>
              <div v-if="item?.sub_custom_menu && item?.sub_custom_menu.length > 0" class="custom_sub_custom_menu">
                <div class="item_detail" v-for="itemChild in item?.sub_custom_menu">
                   <div class="item_icon"  >
                      <CustomLink :url="getLangUrl(itemChild.url, baseUrl, locale)" class="alt-mega-link-icon" @click="toggleMenu($event)" v-if="itemChild.icon" v-html="lazyMenuImages(itemChild.icon)"></CustomLink>
                      <CustomLink :url="getLangUrl(itemChild.url, baseUrl, locale)" class="alt-mega-link"  @click="toggleMenu($event)" ><span v-html="itemChild.title"></span></CustomLink>
                      
                    </div>
                    <div v-if="item.sub_custom_menu?.[0]?.classes?.includes('custom_gold_price')" class="custom_gold_price"> 
                        <div class="item_gole_price"  v-for="(item, price_key) in data_gold_price" :key="price_key">
                          <p class="key_price">{{ item?.sub_title }}:</p>
                          <p class="value_price"><span :class="`price_gold pt_cs gold_${item?.sub_title}`">{{ displayCustomPrice(item?.rate_value) }}</span><span>/g</span></p>
                        </div>
                    </div>
                </div>
              </div>

              <li class="alt-menu-item alt-menu-wrapper" :class="{ 'is_sub_menu': item?.sub_custom_menu && item?.sub_custom_menu.length > 0 }">
                <ul class="alt-menu-wrapper-item alt-megamenu-items">
                  <li class="alt-menu-item"  v-for="children in item.children" @click="toggleMenu($event)" 
                    :class="[
                      { 
                        'alt-menu-icon': children.icon,
                        'alt-menu-has-submenu': children.children,
                        'alt-has-widget-image': children.alt_id && children.alt_id == 'splayout-4'
                      },
                      (children.classes && Array.isArray(children.classes)) ? children.classes.join(' ') : ''
                    ]"
                    v-if="item.layout != 3 && item.layout != 5 && item.layout != 6">
                      <CustomLink :url="getLangUrl(children.url, baseUrl, locale)" class="alt-mega-link-icon" v-if="children.icon" v-html="lazyMenuImages(children.icon)"></CustomLink>
                      <CustomLink :url="getLangUrl(children.url, baseUrl, locale)" class="alt-mega-link" v-if="! children.alt_id" @click="openSubItem($event)"><span v-html="children.title"></span><span v-if="children.menu_item_tag" class="alt-menu-tag">{{children.menu_item_tag}}</span><span class="alt-mega-indicator" v-if="index < item.children.length - 3 "></span></CustomLink>


                      <div class="alt-menu-gallery-listing" v-if="children.alt_id  && children.alt_id != 'splayout-4'">
                        <h4 class="alt-menu-widget-title">{{ children.title }}</h4>
                        <div class="alt-menu-gallery-listing-wrapper">
                          <figure v-for="gallery in children.links"><CustomLink :url="gallery.link"><img loading="lazy" decoding="async" width="150" height="150" :src="gallery.src" alt="" ><span>{{ gallery.caption }}</span></CustomLink></figure>
                        </div>
                      </div>

                      <div class="" v-if="children.alt_id && children.alt_id == 'splayout-4'">
                        <div class="alt-menu-image">
                          <CustomLink :url="getLangUrl(children.url, baseUrl, locale)" class="alt-menu-image">
                            <img loading="lazy" decoding="async" width="600" height="756" class="menu-alt-lazy-img alt-lazy-img" :src="children.img_lazy" :data-original_src="children.img_src" alt="">
                          </CustomLink>

                          <h4 class="alt-menu-block-title"><CustomLink :url="getLangUrl(children.url, baseUrl, locale)">{{ children.title }}</CustomLink></h4>
                        </div>
                      </div>

                      <ul class="alt-submenu" v-if="children.children && (children.classes.join(' ') != 'custom_menu_acf')">
                        <li class="alt-menu-item" v-for="child in children.children">
                          <CustomLink :url="getLangUrl(child.url, baseUrl, locale)" class="alt-mega-link-icon" v-if="child.icon" v-html="lazyMenuImages(child.icon)"></CustomLink>
                          <CustomLink :url="getLangUrl(child.url, baseUrl, locale)" class="alt-mega-link"><span v-html="child.title"></span><span v-if="child.menu_item_tag" class="alt-menu-tag">{{child.menu_item_tag}}</span></CustomLink>
                        </li>
                      </ul>
                      <ul class="alt-submenu custom_acf" v-if="children.children && (children.classes.join(' ') == 'custom_menu_acf')">
                        <div class="custom_item_acf" v-for="child in children.children" :data-id="child.id">
                            <a :href="getLangUrl(child.url, baseUrl, locale)" class="url_item">
                              <img loading="lazy" decoding="async" :src="child.img_src" class="menu-alt-lazy-img alt-lazy-img" :alt="children.title"/>
                              <p class="title_item" v-html="htmlSpecialcharsDecode(child.title)"></p>
                              <span class="cs_price">
                                <p class="price_item" v-html="child.price"></p>
                                <p class="price_regular_item"></p>
                              </span>
                            </a>
                        </div>
                        
                      </ul>

                  </li>



                  <li class="alt-menu-item" v-for="children in item.children" v-if="item.layout == 3">
                    <CustomLink :url="getLangUrl(children.url, baseUrl, locale)">
                      <img loading="lazy" decoding="async" :src="children.img_lazy" :data-original_src="children.img_src" class="menu-alt-lazy-img alt-lazy-img" :alt="children.title"/>
                      <span class="alt-menu-text">{{ children.title }}</span>
                    </CustomLink>
                  </li>
                  <!-- Savillla Laviosa -->
                  <li class="alt-menu-item" v-for="(children, index) in item.children" @click="toggleMenu($event)" :class="{
                      'alt-menu-icon': children.icon,
                      'alt-menu-has-submenu': children.children,
                      'alt-has-widget-image' : children.alt_id && children.alt_id == 'splayout-5',
                      'alt-menu-no-border' :  index == item.children.length - 3,
                      'alt-menu-has-submenu-no-collapse' :  index >= item.children.length - 2 || index == 0 || index == 1,
                      'alt-second-row' : index == 1,
                    }" v-if="item.layout == 5" :data-index="index">

                      <CustomLink :url="getLangUrl(children.url, baseUrl, locale)" class="alt-mega-link-icon" v-if="children.icon" v-html="lazyMenuImages(children.icon)"></CustomLink>
                      <CustomLink :url="getLangUrl(children.url, baseUrl, locale)" class="alt-mega-link" v-if="! children.alt_id" @click="openSubItem($event)"><span v-html="children.title"></span><span class="alt-mega-indicator" v-if="index < item.children.length - 2 && index > 0 "></span></CustomLink>

                      <ul class="alt-submenu" :class="{'alt-submenu-no-collapse': children.children &&  (index == 1 || index >= item.children.length - 2) }" v-if="children.children">
                        <li class="alt-menu-item" v-for="child in children.children">
                          <CustomLink :url="getLangUrl(child.url, baseUrl, locale)" class="alt-mega-link-icon" v-if="child.icon" v-html="lazyMenuImages(child.icon)"></CustomLink>
                          <CustomLink :url="getLangUrl(child.url, baseUrl, locale)" class="alt-mega-link"><span v-html="child.title"></span></CustomLink>
                        </li>
                      </ul>

                      <div class="" v-if="children.alt_id && children.alt_id == 'splayout-5'">
                        <div class="alt-menu-image">
                          <CustomLink :url="getLangUrl(children.url, baseUrl, locale)" class="alt-menu-image">
                            <img loading="lazy" decoding="async" width="600" height="756" class="menu-alt-lazy-img alt-lazy-img" :src="children.img_lazy" :data-original_src="children.img_src" alt="">
                          </CustomLink>
                        </div>
                      </div>
                  </li>
                  <li class="alt-menu-item" v-for="(children, index) in item.children" @click="toggleMenu($event)" :class="{
                      'alt-menu-icon': children.icon,
                      'alt-menu-has-submenu': children.children,
                      'alt-has-widget-image' : children.alt_id && children.alt_id == 'splayout-6',
                      'alt-menu-has-submenu-no-collapse' :  index >= item.children.length - 3,
                      'alt-fullwidth-row': index == item.children.length - 3,
                      'alt-last-row': index == item.children.length - 1,
                      'alt-menu-no-border' :  index == item.children.length - 4,
                    }" v-if="item.layout == 6" :data-index="index">

                      <CustomLink :url="getLangUrl(children.url, baseUrl, locale)" class="alt-mega-link-icon" v-if="children.icon" v-html="lazyMenuImages(children.icon)"></CustomLink>
                      <CustomLink :url="getLangUrl(children.url, baseUrl, locale)" class="alt-mega-link" v-if="! children.alt_id" @click="openSubItem($event)"><span v-html="children.title"></span><span class="alt-mega-indicator" v-if="index < item.children.length - 3 "></span></CustomLink>

                      <ul class="alt-submenu" :class="{'alt-submenu-no-collapse': children.children && index >= item.children.length - 3, }" v-if="children.children">
                        <li class="alt-menu-item" v-for="child in children.children">
                          <CustomLink :url="getLangUrl(child.url, baseUrl, locale)" class="alt-mega-link-icon" v-if="child.icon" v-html="lazyMenuImages(child.icon)"></CustomLink>
                          <CustomLink :url="getLangUrl(child.url, baseUrl, locale)" class="alt-mega-link"><span v-html="child.title"></span></CustomLink>
                        </li>
                      </ul>

                      <div class="" v-if="children.alt_id && children.alt_id == 'splayout-6'">
                        <div class="alt-menu-image">
                          <CustomLink :url="getLangUrl(children.url, baseUrl, locale)" class="alt-menu-image">
                            <img loading="lazy" decoding="async" width="600" height="756" class="menu-alt-lazy-img alt-lazy-img" :src="children.img_lazy" :data-original_src="children.img_src" alt="">
                          </CustomLink>

                          <h4 class="alt-menu-block-title"><CustomLink :url="getLangUrl(children.url, baseUrl, locale)">{{ children.title }}</CustomLink></h4>
                        </div>
                      </div>
                  </li>
                </ul>
              </li>
            </ul>
          </li>

          <li class="alt-megamenu-bottom"  @click="toggleMenu($event)">
            <ul>
              <li class="alt-menu-item" v-for="itemBottom in menus.bottom">
                <CustomLink :url="getLangUrl(itemBottom.url, baseUrl, locale)" class="alt-mega-link alt-has-submenu-toggle" :class="itemBottom.classes ? itemBottom.classes.join(' ') : ''" @click="toggleMenuBottom($event)" v-if="itemBottom.children"><span v-html="itemBottom.title"></span></CustomLink>
                <CustomLink :url="getLangUrl(itemBottom.url, baseUrl, locale)" class="alt-mega-link" :class="itemBottom.classes ? itemBottom.classes.join(' ') : ''" v-else><span v-html="itemBottom.title"></span></CustomLink>

                <ul class="alt-sub-megamenu-bottom" v-if="itemBottom.children">
                  <li class="alt-menu-item" v-for="children in itemBottom.children">
                    <CustomLink :url="getLangUrl(children.url, baseUrl, locale)" class="alt-mega-link" :class="children.classes ? children.classes.join(' ') : ''"><span v-html="children.title"></span></CustomLink>
                  </li>
                </ul>
              </li>
            </ul>
          </li>
        </ul><!-- .end: menu-mobile-->
    </div>
  </div>


  <div id="alt-header-form-mobile" style="display: none;" :class="isSearchMobile ? 'active' : ''">
    <form id="form_search_mobile" role="search" method="get" class="search-form" action="https://www.skjewellery.com.my/">
      <label>
        <span class="screen-reader-text">Search for:</span>
        <input type="search" class="search-field" placeholder="Search …" value="" name="s" autocomplete="off" style="display: none;" ref="searchField">
      </label>
      <input type="submit" class="search-submit" value="Search">
    </form>
  </div>
</template>

<script lang="ts" setup>
// const wooStore = useWooStore();
const isFirstLoad = ref(false);
const { $file } = useNuxtApp();
const userStore = useUserStore();
const runtimeConfig = useRuntimeConfig();
const isSearchMobile = ref(false);
const menus = ref();
const shippingCountry = ref('');
const shippingCountryCode = ref('');
const shippingFlag = ref('');
const router = useRouter();
const checkCart = ref(true);
const wooStore = useWooStore();
import { displayCustomPrice } from "~/utils/displayPrice";
import { htmlSpecialcharsDecode } from '@/utils/helpers'
import { useI18n } from 'vue-i18n';
const { locale } = useI18n();
import { getLangUrl } from '~/utils/getLangUrl';
const baseUrl = runtimeConfig.public.BASE_URL;


const handleLogOut = (e:any) => {
  e.preventDefault();
  userStore.logout();
  localStorage.clear();
  router.push("/my-account/");
};

const setShippingCountry = () => {
    const popupDisplay = getCookie('altcs_popup_display');
    if (popupDisplay) {
        // console.log('cookie', popupDisplay);
        shippingCountry.value = decodeURIComponent(popupDisplay);
    }
    const detectCountry = getCookie('altcs_detect_country');
    // console.log('cookie', detectCountry);
    if (detectCountry) {
        shippingCountryCode.value = decodeURIComponent(detectCountry);
    }
};

const userMenu = ref(null)

function closeUserMenu() {
  if (userMenu.value?.classList.contains('user-menu-active')) {
    userMenu.value.classList.remove('user-menu-active')
  }
}
const share_key_cookie = ref("");

const pageTranslations = usePageTranslations();

// Build query string from route
const buildQueryString = (): string => {
  const query = route.query;
  if (!query || Object.keys(query).length === 0) {
    return '';
  }
  const queryParams = new URLSearchParams();
  Object.entries(query).forEach(([key, value]) => {
    if (Array.isArray(value)) {
      value.forEach(v => queryParams.append(key, v));
    } else {
      queryParams.append(key, value as string);
    }
  });
  const queryString = queryParams.toString();
  return queryString ? `?${queryString}` : '';
};

// Compute localized paths with reactivity
const localizedPathEn = computed(() => {
  const trans = pageTranslations.value;
  const path = route.path;
  const queryString = buildQueryString();
  
  console.log('[computed EN] trans:', trans, 'path:', path);
  
  if (trans?.['en']?.slug) {
    const result = `/${trans['en'].slug}${queryString}`;
    console.log('[computed EN] returning slug:', result);
    return result;
  }
  const result = (path.replace(/^\/ms-my/, '') || '/') + queryString;
  console.log('[computed EN] returning fallback:', result);
  return result;
});

const localizedPathMs = computed(() => {
  const trans = pageTranslations.value;
  const path = route.path;
  const queryString = buildQueryString();
  
  if (trans?.['ms-my']?.slug) {
    const result = `/ms-my/${trans['ms-my'].slug}${queryString}`;
    console.log('[computed MS] returning slug:', result);
    return result;
  }
  // Remove trailing slash and /ms-my prefix
  const cleanPath = path.replace(/^\/ms-my/, '').replace(/\/$/, '');
  const result = cleanPath ? `/ms-my${cleanPath}${queryString}` : `/ms-my${queryString}`;
  return result;
});

// Navigate handler for language links
const navigateToLocalized = (langPath: string) => {
  langOpen.value = false
  router.push(langPath);
};


const setShippingFlag = () => {
    const detectCountryFlag = getCookie('altcs_detect_country_flag');
    if (detectCountryFlag) {

        shippingFlag.value = decodeURIComponent(detectCountryFlag);
        // console.log('cookie', shippingFlag.value);
    }
};
const emit = defineEmits<{
    (e: 'toggle-minicart'): void
}>();

const toggleMiniCart = (event: Event) => {
  event.preventDefault();
  emit('toggle-minicart');
  void import('@/assist/MiniCart').then(({ getInforCartToDataLayer }) => {
    getInforCartToDataLayer(true);
  });
}


import { toggleHeaderUser, headerUserMenuCloseOutside } from '@/assist/HeaderDesktop';
import { toggleMenu, closeMenu, jumpItem, openSubItem, backMenu,closePopupSelectCountry, toggleMenuBottom, handleWindowSizeChange , shopPopupSelectCountry} from '@/assist/HeaderMobile';
import CustomLink from '~/components/CustomLink.vue';
import { lazyMenuImages } from '~/utils/lazyMenuImages';
const route = useRoute()
const langOpen = ref(false)
const langDropdownRef = ref<HTMLElement | null>(null)
const isMsMy = computed(() => route.path.startsWith('/ms-my'))
const currentLang = computed(() => isMsMy.value ? 'MS' : 'EN')
const toggleLangDropdown = () => { langOpen.value = !langOpen.value }
interface Props {
    cartItem: number
}
const handleClickOutside = (event) => {
  event.stopPropagation();
  const selectElement = document.querySelector(".popup-content");
  const button = document.querySelector(".alt-header-country-selector");
  const button2 = document.querySelector(".country-selector_mobile");

  if (selectElement && !selectElement.contains(event.target) && button && !button.contains(event.target) && button2 && !button2.contains(event.target)) {
    closePopupSelectCountry();
  }
  if (langDropdownRef.value && !langDropdownRef.value.contains(event.target as Node)) {
    langOpen.value = false;
  }
};

const getLocalizedPath = (targetLocale: 'en' | 'ms') => {
    const currentPath = route.path;
    const cleanPath = currentPath.replace(/^\/ms-my/, '') || '/';
    
    if (targetLocale === 'ms') {
        return `/ms-my${cleanPath}`;
    } else {
        // 'en'
        return cleanPath;
    }
}
const searchInput = ref('');
    const normalizeSearchTerm = (term: string): string => {
        return term
            .trim()
            .replace(/\s+/g, ' ')
            .replace(/\+/g, ' ')
            .trim();
    };
  const handleSearchSubmit = async (event: Event) => {
      event.preventDefault();
      const searchValue = searchInput.value;
      const normalizedSearch = normalizeSearchTerm(searchValue);
      const encodedSearch = encodeURIComponent(normalizedSearch);
      searchInput.value = '';
      
      // Close menu if it's open
      if (document.body.classList.contains('alt-body-open-menu')) {
        const btnHamburger = document.getElementsByClassName('alt-header-hamburger');
        if (btnHamburger.length > 0) {
          (btnHamburger[0] as HTMLElement).click();
        }
      }
      if(locale.value === 'ms-my') {
        await router.push(`/${locale.value}/search?q=${encodedSearch}`);
      }else{
        await router.push(`/search?q=${encodedSearch}`);
      }
  };
const updateData = ref();
const updateProductInfo = () => {
  const validIds = updateData.value.map(p => String(p.product_id))

  const allElements = document.querySelectorAll('.custom_item_acf')

  allElements.forEach(el => {
    const dataId = el.getAttribute('data-id')

    if (!validIds.includes(dataId)) {
      el.style.display = 'none'
      return
    }

    el.style.display = '' 

    const product = updateData.value.find(p => String(p.product_id) === dataId)
    if (!product) return

    const img = el.querySelector('img')
    const link_item = el.querySelector('.url_item')
    const title = el.querySelector('.title_item')
    const price = el.querySelector('.price_item')
    const price_regular = el.querySelector('.price_regular_item')

    if (img) img.src = product.cover?.src || ''
    if (link_item) link_item.href = product.slug || ''
    if (title) title.textContent = htmlSpecialcharsDecode(product.title) || ''

    if (price) {
      const price_new = displayCustomPrice(product.price)
      if (product.price == 0) {
        price.textContent = ''
      } else {
        price.textContent = `${price_new || ''}`
      }
    }

    if (product.price != product.regular_price) {
      const formattedPrice = displayCustomPrice(product.regular_price)
      if (price_regular) price_regular.textContent = `U.P.${formattedPrice || ''}`
      if (product.regular_price == '' || product.regular_price == 0) {
        if (price_regular) price_regular.textContent = ''
      }
    }
  })
}
const getDataMenuProducts = async (listId) => {
    try {
        if (listId){
            const response = await $file.get(`${runtimeConfig.public.API_URL}productids/${listId}`, {
              headers: {
                Authorization: `Bearer ${userStore.csrf}`,
                'X-API-Server': userStore.csrf_server
              },
            });
            if (response.success) {
              updateData.value = response.data;
              updateProductInfo();
            }
        }
    } catch (e) {
        console.error("Error fetching recently viewed products:", e);
    }
};

const update_product = async () => {
  const elements = document.querySelectorAll('.custom_item_acf');
  const dataIds = Array.from(elements).map(el => el.getAttribute('data-id'))

  if (dataIds.length > 0) {
    const listId = dataIds.join(',')
    await getDataMenuProducts(listId)
  } else {
    console.warn('⚠️ Not find Id Product')
  }
}
const data_gold_price = ref();
const data_gold_999 = ref();
const data_gold_916 = ref();
const getDataGoldPrice = async () => {
    try {
        const response = await $file.get(`${runtimeConfig.public.BASE_URL}api/wp-json/skj/v1/gold-price-table`, {
          headers: {
            Authorization: `Bearer ${userStore.csrf}`,
            'X-API-Server': userStore.csrf_server
          },
        });
        data_gold_price.value = response?.price_labour ?? [];
        // data_gold_916.value = response.price_labour[0]?.rate_value ?? '';
        // data_gold_999.value = response.price_labour[1]?.rate_value ?? '';

        // const price_916 = displayCustomPrice(data_gold_916.value);
        // const price_999 = displayCustomPrice(data_gold_999.value);

        // const el916 = document.querySelector('.pt_cs.gold_916');
        // const el999 = document.querySelector('.pt_cs.gold_999');

        // if (el916 && price_916) el916.textContent = price_916;
        // if (el999 && price_999) el999.textContent = price_999;
        
    } catch (e) {
        console.error("Error fetching recently viewed products:", e);
    }
};

onMounted(async () => {
  document.addEventListener("click", handleClickOutside);
  share_key_cookie.value = userStore.user?.wishlist_sharekey || '';
  const currentShareKey = getCookie("share_key_wishlist");
  if (share_key_cookie.value && currentShareKey !== share_key_cookie.value) {
    setCookie('share_key_wishlist', share_key_cookie.value, 1);
  }
  await nextTick()
  setTimeout(() => {
      update_product();
      getDataGoldPrice();
  }, 800)

});

onBeforeUnmount(() => {
  document.removeEventListener("click", handleClickOutside);
});
withDefaults(defineProps<Props>(), {});
  const getData = async() => {
    //console.log('xxx');
    try {
      let language = '';
      if (window.location.href.indexOf("ms") !== -1) {
        language = '_ms';
      }
      const response = await $file.get(`menu/header-menu-mobile.json`, {
        headers: {
          Authorization: `Bearer ${userStore.csrf}`,
          'X-API-Server': userStore.csrf_server
        },
      });

      // const response111 = await fetch(`https://skjmy.oanglelab.com/api/data/menu/header-menu-mobile.json?v=10333122`);
      // const response = await response111.json();

      menus.value = response;
    } catch (err: any) {
      //console.log('err.response', err);
    }
  }
  const searchField = ref<HTMLInputElement | null>(null)

  const openSearchMobile = async (event: Event) => {
    event.preventDefault()
    isSearchMobile.value = true;
    if (isSearchMobile.value && searchField.value) {
      searchField.value.style.display = 'block'

      await nextTick()
      searchField.value.focus()

      const clickEvent = new MouseEvent('click', {
        bubbles: true,
        cancelable: true,
        view: window
      })
      searchField.value.dispatchEvent(clickEvent)
    }

    if (document.body.classList.contains('alt-body-open-menu')) {
      const btnHamburger = document.getElementsByClassName('alt-header-hamburger')
      if (btnHamburger.length > 0) {
        (btnHamburger[0] as HTMLElement).click()
      }
    }

    if (!isSearchMobile.value && searchField.value) {
      searchField.value.style.display = 'none'
    }
  }
const checkPageCart = () => {
  const slug = router.currentRoute.value.name;
  if(slug == "cart"){
    checkCart.value = false;
  }else{
    checkCart.value = true;
  }
}
watch(
  () => router.currentRoute.value.name,
  () => {
    checkPageCart();
  }
);
checkPageCart();
onMounted(() => {
  if (process.client) {
    if (window.innerWidth < 1020) {
      getData();
      // window.addEventListener('touchstart', function(e) {
      //   console.warn('touchstart: header menu mobile');
      //   if( ! isFirstLoad.value ) {
      //     getData();

      //     isFirstLoad.value = true;
      //   }

      // });
    }
    //isFirstLoad
    handleWindowSizeChange();
    window.addEventListener("resize", handleWindowSizeChange);
  }
  setTimeout(() => {
    altLazyIO();
  }, 1000);

  // userStore.menuBottomMobile();
  setTimeout(() => {
    setShippingCountry();
  }, 2000);
  // setShippingCountry();
  setShippingFlag();
});
</script>

<style scoped>

</style>
